import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    paddingBottom: 32,
    boxSizing: 'border-box',
    '& .stepper': {
      borderLeft: '',
    },
  },
  boxes: {
    '& .storage': {
      height: 40,
      width: 40,
      borderRadius: 4,
      boxSizing: 'border-box',
      '&.available': {
        background: '#7ccfbd',
      },
      '&.not_available': {
        background: Colors.primary,
      },
      '&.empty': {
        background: 'transparent',
        border: '1px solid #ABB1BB',
      },
      '&.pointer': {
        cursor: 'pointer',
      },
      '&.selected': {
        border: '2px solid #BB6238',
      },
    },
  },
};

export default styles;
